import { Component } from '@angular/core';

@Component({
  templateUrl: './check-box-list-box.html'  
})
export class CheckBoxListBoxComponent { 

    constructor() {
      var items = [
        { Name:'Apple' },
        { Name:'Banana' },
        { Name:'Cherry' },
        { Name:'Orange' },
        { Name:'Pineapple' },        
        { Name:'Strawberry' },
        { Name:'Tomato' },         
      ];

      this.ItemsSource = items.slice();
      this.SelectedItems = items.slice();
    }

    public ItemsSource;
    public SelectedItems;
}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/check-box-list-box/check-box-list-box-component.ts